import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AccountRolesFetchFailedAction = {
	type: 'ACCOUNT_ROLES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AccountRolesFetchFailedAction => ({
	type: 'ACCOUNT_ROLES_FETCH_FAILED',
	payload,
});
